import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import {
  ExperienceDetailResource,
  ExperienceResource,
} from '../../../../../CurrentCollectionStep/BuilderV2/Types';
interface Props {
  experienceDetailResource: ExperienceDetailResource;
  experienceResource: ExperienceResource;
}

function ExperienceTimeCommitment({ experienceDetailResource, experienceResource }: Props) {
  return (
    <div className="flex flex-col gap-y-1">
      {experienceDetailResource.payload.duration
        .map((duration) => (
          <Typography variant="caption" as="p">
            <T kind="{{count}} week" count={duration} />
          </Typography>
        ))
        .getOrElse(emptyFragment)}
      {experienceDetailResource.payload.hours_per_week
        .map((count) => (
          <Typography variant="caption" as="p">
            <T kind="{{count}} hour per week" count={count} />
          </Typography>
        ))
        .getOrElse(emptyFragment)}
      {experienceResource.payload.total_hours
        .map((totalHours) => (
          <Typography variant="caption" as="p">
            <T kind="{{count}} total hour" count={totalHours} />
          </Typography>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}
export default observer(ExperienceTimeCommitment);
